import styled, { css } from 'styled-components'
import gigplanetTheme from '../../styles/gigplanetTheme'

export const MobileMenuWrapper = styled.div`
  position: relative;
`

export const MobileMenuButton = styled.button.attrs(props => ({
  type: 'button',
}))`
  appearance: none;
  border: 0;
  padding: 0 5px 0 0;
  background: transparent;
  z-index: 1;

  ${({ useHamburger }) =>
    useHamburger &&
    css`
      padding: 0;
    `};
`

export const MobileMenuButtonContent = styled.span`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 50px;
  font-size: 14px;
  font-weight: 600;

  svg {
    fill: ${gigplanetTheme.color.primary};
    transition: transform 0.2s ease-in-out;

    ${({ isOpen }) =>
      isOpen &&
      css`
        transform: rotate(180deg);
      `};
  }
`

export const HamburgerButtonContent = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`

export const HeaderBackground = styled.div`
  background: white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
`

export const MobileMenuContent = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  transform: translateY(-100%);
  transition: transform 0.2s ease-out;
  padding: 60px 0 10px;

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: translateY(0%);
    `};
`

export const ScrollContainer = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`

export const UnreadCountWrapper = styled.div`
  position: absolute;
  top: 3px;
  right: -5px;
`
